import { Box, Typography } from '@mui/material'
import React from 'react'
import { useAdmin } from '../AdminContext';
import SubTitle from '../../Public/MainComponents/SubTitle';
import { useMobile } from '../../../base';

function formatFirestoreTimestamp(timestamp) {
    return timestamp?.toDate().toLocaleString();
}

export default function AdminPaymentsLast() {
    const { payments } = useAdmin() || {};
    const mobile = useMobile();

    return (
        <>
            <SubTitle title={'Poslední platby'} />
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', gap: '12px' }}>
                {Boolean(payments) && payments.map((p, i) => <Box key={"ADMINLP" + i}
                    sx={{ display: 'flex', justifyContent: 'flex-start', textAlign: 'left', flexDirection: 'column', borderRadius: '20px', border: '1px solid rgba(0, 0, 0, 0.12)', p: '20px' }}>
                    <Typography><span style={{ marginRight: '16px' }}><b>OrderId:</b> {p.orderId}</span><b>PaymentId:</b> {p.paymentId}</Typography>
                    <Typography><b>Email:</b> {p.email}</Typography>
                    <Typography><b>Url:</b> <a href={"https://carskaut.com/cs/result/" + p.orderId} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>{mobile ? "ZDE" : `https://carskaut.com/cs/result/${p.orderId}`}</a></Typography>
                    <Typography><b>VIN:</b> {p.vin || "NE"}<span style={{ marginInline: '16px' }}><b>KUPONY:</b> {p.coupon_count || 0}</span><b>SLEVA:</b> {p.sale_coupon || "NE"}{p.coupon_sale ? ` (${p.coupon_sale * 100}%)` : ""}</Typography>
                    <Typography><b>Datum:</b> {formatFirestoreTimestamp(p.createdAt)}</Typography>
                </Box>)}
            </Box>
        </>
    )
}
